import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, LanguageService, UserService } from '@whbabtec-services';
import { WHBABTEC_DEFAULT_LANG, WhbabtecLanguages } from '@whbabtec-types';
import { Subscription } from 'rxjs';

@Component({
  selector: 'whbabtec-signin-oidc',
  template: `<div
    class="flex h-full items-center justify-center"
  >
    <p>Signing you in...</p>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SigninOidcComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private languageService: LanguageService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    await this.authService.fetchToken();
    await this.userService.init();

    this.subscriptions.add(
      this.userService.user$.subscribe((user) => {
        if (user) {
          const lang =
            (user.language as WhbabtecLanguages) || WHBABTEC_DEFAULT_LANG;
          this.languageService.syncLanguage(lang);
          this.router.navigate([`/${lang}/complaints`]);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
